// extracted by mini-css-extract-plugin
export default {"overley":"ModalPlay_overley__rKEtE","modal":"ModalPlay_modal__RxODF","video":"ModalPlay_video__k6D1T","iconeFechar":"ModalPlay_iconeFechar__sO5Md"};